angular.module('smartorg.r6.acts.portfolioUncertainty', []);
require('./portfolioUncertainty-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.portfolioUncertainty';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/portfolio-uncertainty/app/js/plumbing/app.js